module.exports = __webpack_public_path__ + "img/stripe.c961fe98.svg";